<template>
	<div>
		<div class="flex talentCell">
			<img :src="row.head" alt="" class="imgs" />
			<div>
				<div class="fz-14 yx-color-pure-1">{{ row.anchor_name }}</div>
				<div class="fz-12 yx-color-gray" v-if="$isDy(row.platform_id) || $isKs(row.platform_id)">{{ row.anchor_account }}</div>
				<div class="fz-12 yx-color-gray" v-else>{{ row.anchor_uid || '-' }}</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="less" scoped>
.imgs {
	width: 40px;
	height: 40px;
	border-radius: 50% 50%;
	margin-right: 15px;
}
</style>
